const mergeConfiguration = (givenConfiguration, defaultConfiguration) => {
  return { ...defaultConfiguration.options, ...givenConfiguration.options, ...defaultConfiguration, ...givenConfiguration };
};

export { mergeConfiguration };
